<template>
  <v-card flat class="pa-2">
    <v-row>
      <v-col cols="12">
        <v-card-title>افزودن لینک فایل صوتی</v-card-title>
        <v-card-subtitle>
          برای استفاده از صوت با لینک خارجی، لطفا فیلدهای زیر را پر نمایید
        </v-card-subtitle>
      </v-col>
      <v-col v-for="(list, i) in listLink" :key="i" class="pa-4" cols="12">
        <v-text-field
          v-model="list.full_path"
          outlined
          dense
          label="لینک صوت"
          hint="آدرس (لینک) صوت مورد نظر"
          :disabled="
            audioSelects?.length + listLink?.length - 1 >= maxChoseLength
          "
        >
          <template
            v-if="audioSelects?.length + listLink?.length < maxChoseLength"
            v-slot:append
          >
            <span
              style="cursor: pointer"
              class="d-flex justift-content-center align-items-center"
              @click="
                listLink.push({
                  title: '',
                  full_path: '',
                  id: Math.ceil(Math.random() * 99999),
                })
              "
            >
              <v-icon>mdi-plus</v-icon>
              افزودن
            </span>
          </template>
          <template v-if="i > 0" v-slot:append-outer>
            <span
              style="cursor: pointer"
              class="d-flex justift-content-center align-items-center"
              @click="listLink.splice(i, 1)"
            >
              <v-icon>mdi-delete</v-icon>
            </span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          :disabled="audios?.length === maxChoseLength"
          @click="addLink"
          outlined
          color="green"
          class="w-100"
        >
          <v-icon v-if="audioSelects?.length < maxChoseLength">mdi-plus</v-icon>
          {{
            audioSelects?.length >= maxChoseLength
              ? this.$t('max_files_limit', { count: persian(maxChoseLength) })
              : this.$t('add')
          }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import axios from "axios";
import { Bus } from "../../../../../main";
export default {
  name: "addLinkAudio",
  props: { audios: [Array], audioSelects: [Array] },
  data() {
    return {
      listLink: [],
    };
  },
  inject: {
    maxChoseLength: { default: 9999 },
  },

  mounted() {
    this.listLink = [
      { full_path: "", title: "", id: Math.ceil(Math.random() * 99999) },
    ];
  },
  methods: {
    createId() {
      let id = Math.ceil(Math.random() * 99999);
      return id;
    },

    async addLink() {
      if (
        this.listLink?.length + this.audioSelects?.length >
        this.maxChoseLength
      ) {
        this.$toast.warning(
          `شما نمیتوانید بیشتر از ${this.maxChoseLength} فایل اضافه کنید`
        );
      } else {
        let cons = true;
        this.listLink.map((item, i) => {
          let link = this.hasAudioExtension(item.full_path);
          if (!link) {
            cons = false * cons;
            this.$toast.error("شما نمیتوانید لینکی غیر از فایل صوتی وارد کنید");
            if (this.listLink.length == 1) {
              this.listLink = [
                {
                  title: "",
                  full_path: "",
                  id: Math.ceil(Math.random() * 99999),
                },
              ];
            } else {
              let fil = this.listLink.filter(
                (fil) => item.full_path !== fil.full_path
              );
              if (fil.length == 0) {
                this.listLink = [
                  {
                    title: "",
                    full_path: "",
                    id: Math.ceil(Math.random() * 99999),
                  },
                ];
              } else {
                this.listLink = fil;
              }
            }
          } else {
            cons = true * cons;
          }
        });

        if (cons) {
          Bus.$emit("linklist", this.listLink);
          this.listLink = [
            { full_path: "", title: "", id: Math.ceil(Math.random() * 99999) },
          ];
        }
      }
    },
    hasAudioExtension(url) {
      if (url == "") {
        this.$toast.error("لینک فایل صوتی نمیتواند خالی باشد");
        return false;
      }
      const audioExtensions = [
        ".mp3",
        ".wav",
        ".ogg",
        ".aac",
        ".m4a",
        ".flac",
        ".webm",
      ];
      const lowerUrl = url.toLowerCase();
      return audioExtensions.some((ext) => lowerUrl.endsWith(ext));
    },
  },
};
</script>

<style></style>
